import { defineStore } from "pinia";
import { useUserStore } from "@/stores/UserStore";
import config from "@/configs/config";
import MyPlugin from "@/plugins/plugin";
import languages from "@/configs/language";
import mainAPI from "@/api/mainAPI";
import axios from "axios";
// import exampleAPI from "@/api/exampleAPI";

export const useGeneralStore = defineStore("GeneralStore", {
  state: () => ({
    showMobileSidebar: false,
    isLoading: false,
    choosedLanguage: "english",
    activeMenu: "",
    activeGroupMenu: "",
    lastPath: "",
    isLogout: false,
    activeOwner: null,
    idleTime: 0,
    logoAi: "",
    lastOpened: null,
    isRefreshingToken: false,

    //forms
    isSubmitting: false,

    //general dialog
    generalDialogVisible: false,
    generalDialogMsg: "",
    generalDialogBackdrop: true,
    listMenu: [],
  }),
  getters: {
    // getProducts: (state) => state.products,
  },
  actions: {
    toggleMobileSidebar(state) {
      if (state == null) {
        this.showMobileSidebar = !this.showMobileSidebar;
      } else {
        this.showMobileSidebar = state;
      }
    },
    toggleLanguage() {
      this.choosedLanguage =
        this.choosedLanguage == "indonesia" ? "english" : "indonesia";
    },
    showGeneralDialog(message, backdrop) {
      this.generalDialogMsg = message;
      this.generalDialogBackdrop = backdrop;
      this.generalDialogVisible = true;
    },
    setActiveOwner() {
      const activeOwnerIndex = config.owner.findIndex(
        (owner) => owner.id === config.activeOwner
      );

      if (activeOwnerIndex !== -1) {
        this.activeOwner = config.owner[activeOwnerIndex];
      } else {
        const activeOwnerIndex = config.owner.findIndex(
          (owner) => owner.id === 1
        );
        this.activeOwner = config.owner[activeOwnerIndex];
      }
    },
    resetIdleTime() {
      this.idleTime = 0;
    },
    addIdleTime() {
      this.idleTime++;
    },
    async getListMenu(params) {
      const userStore = useUserStore();
      const timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      // API Request
      let apiData = {
        apirequest: "GETMENUBYROLE",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };
      let body = {
        apidata: apiData,
        params: params,
      };
      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );
      let header = {
        "X-Signature": signature,
      };

      // API Response
      let res = await mainAPI.requestHandler(header, body);
      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        const raw = res.data.data[0] || [];
        this.listMenu = raw.filter(m => m && m.label);
        return { status: "ok", message: "Success", data: res.data.data };
      } else {
        let resp = {
          status: "not-ok",
          message: `${languages[this.choosedLanguage]["err_msg_500"]}.`,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }
        return resp;
      }
    },
    async getIsAi() {
      const userStore = useUserStore();
      const timestamp = MyPlugin.formatDate(new Date(), "timestamp");
      
      const params = {
        action: "get",
        key: "IS_AI",
        user_id : this.user_id,
        company_id : this.company_id,
        is_active : -1
      }

      let apiData = {
        apirequest: "GETCUSTOM",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };
      let body = {
        apidata: apiData,
        params: params,
      };
      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );
      let header = {
        "X-Signature": signature,
      };

      // API Response
      let res = await mainAPI.requestHandler(header, body);
      
      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        if(res.data.data[0]){
          this.logoAi = JSON.parse(res.data.data[0].value);
        
          if (this.logoAi) {
            this.logoAi = this.logoAi.supported_logo;
          } else {
              this.logoAi = "poweredby Forwarder Logo.svg";
          }
        }else{
          this.logoAi = "poweredby Forwarder Logo.svg";
        }
      } else {
        this.logoAi = "poweredby Forwarder Logo.svg";
      }
      // console.log(this.logoAi)
    },
    async uploadForm(params, file) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();
      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");
    
      let apiData = {
        "apirequest": "UPLOADFORM",
        "user_id": userStore.user_id,
        "user_key": userStore.user_key,
        "timestamp": timestamp,
      };
    
      let body = new FormData();
      body.append("apidata", JSON.stringify(apiData));
      body.append("params", JSON.stringify(params));
      body.append("file", file);
    
      let signature = MyPlugin.generateSignature({ apidata: apiData, params: params }, userStore.user_key, timestamp);
      let header = { "X-Signature": signature };
    
      let res = await axios.post(
        `${config.baseApiUrl}/requesthandler`,
        body,
        {
          headers: {
            ...header,
            Authorization: `Bearer ${userStore.access_token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
    
      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        return { status: "ok", message: "Success" };
      } else {
        let resp = { status: "not-ok", message: `${languages[generalStore.choosedLanguage]["err_msg_500"]}.` };
        if (res && res.status && res.status == 400 && res.data && res.data.msg) {
          resp.message = res.data.msg;
        }
        return resp;
      }
    },
    async getCompany(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
          "apirequest": "GETCOMPANY",
          "user_id": userStore.user_id,
          "user_key": userStore.user_key,
          "timestamp": timestamp,
      }

      let body = {
          apidata: apiData,
          params: params
      }

      let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);

      let header = {
          "X-Signature": signature
      }

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
          let resp = { status: "ok", message: "Success", data: res.data.data }
          return resp;
      } else {
          let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
          if (res && res.status && res.status == 400 && res.data && res.data.msg) {
              resp.message = res.data.msg
          }

          return resp;
      }
    },
    async updateInvoiceNote(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
          "apirequest": "UPDATEINVOICENOTE",
          "user_id": userStore.user_id,
          "user_key": userStore.user_key,
          "timestamp": timestamp,
      }

      let body = {
          apidata: apiData,
          params: params
      }

      let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);

      let header = {
          "X-Signature": signature
      }

      let res = await mainAPI.requestHandler(header, body);
      
      if (res && res.status && res.status == 200 && res.data.status == "ok") {
          let resp = { status: "ok", message: "Success" }
          return resp;
      } else {
          let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
          if(res && res.status && res.status == 400 && res.data && res.data.msg) {
              resp.message = res.data.msg
          }
          
          return resp;
      }
    },
  },
  persist: {
    key: config.activeOwner == 1 ? `generalStore_${config.owner[0].localStorageKey}` : `generalStore_${config.owner[1].localStorageKey}`,
    paths: [
      "activeMenu",
      "activeGroupMenu",
      "idleTime",
      "lastOpened",
      "apiBucketIsEmpty",
    ],
  },
});
